<template lang="pug">
	section.v-page-section-main.page-section-main(v-if="section" :style="{backgroundImage: section?.background ? `url(${section.background})` : '#FFFFFF' }")
		.page-section-main__cover
		.container
			a.page-section-main__link(v-if="section.link" :href="section.link?.href")
				img.page-section-main__icon(v-if="section.link.img"
					:src="section.link.img?.src"
					:alt="section.link.img?.alt")
				span.page-section-main__name(v-if="section.link.text") {{ section.link.text }}
			.page-section-main__content
				h1.page-section-main__title(v-if="section.title") {{ section.title }}
				.page-section-main__subtitle(v-if="section.subtitle")  {{ section.subtitle }}
				slot(name="filters" )


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			section: null
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>